import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';

export function liquidityWarningBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Market order of {parsedStatusObj.symbol ? parsedStatusObj.symbol : ''}
        replaced with limit order at{' '}
        {parsedStatusObj.adjustedLimitPrice
          ? ApplyRounding(Number(parsedStatusObj.adjustedLimitPrice), 2)
          : ''}{' '}
        due to thin market conditions.
      </Body3>
    </td>
  );
}
